import React from "react";
import LegalLayout from "@/components/LegalLayout";

const TERMS = [
  {
    title: "Illegal substances",
    body: "We strictly prohibit consumption of illegal substances at the property.",
  },
  {
    title: "Smoking",
    body: "If smoking, use only the outdoor spaces. Please use ashtrays for this purpose.",
  },
  {
    title: "Decor",
    body: "We do not allow sticking of any decorations, use of party poppers or confetti. You are responsible for removing any decorations used at the place.",
  },
  {
    title: "Power cuts",
    body: "Since the property is in a rural area, during rains, please expect some power cuts. We have a UPS that will run fans and necessary lights.",
  },
  {
    title: "Projector",
    body: "As you are aware, ours is an outdoor projector. In extremely windy weather, the projector screen cannot stay in place — this bit is out of our control, so please wait for the weather to get better to use the projector setup. Please do not use the projector without reading our short usage PDF, and please have the screen up immediately post use.",
  },
  {
    title: "Additional guests",
    body: "Only the number of people for whom the booking is made are allowed into the property. Floating guests are not permitted. Additional guests require our approval and are subject to extra charges. Drivers and other helps are counted as additional guests if residing in the property.",
  },
  {
    title: "Furniture",
    body: "Furniture at the property should not be moved (except chairs).",
  },
  {
    title: "Trash",
    body: "There are trash bins in every space — please drop your trash in there. The place is a little windy, which might make the trash fly around. This would be difficult for both the cleaning staff and the guests alike!",
  },
  {
    title: "Pond",
    body: "Ours is a natural pond which has its own supportive ecosystem (sand, fish, algae that feeds the fish, etc). Putting your legs in or getting inside the pond is not permitted, for the benefit of the guests and the fish.",
  },
];

export default function TermsPage() {
  React.useEffect(() => {
    document.title = "Terms & Conditions | Mrinmaya vacation home";
  }, []);

  return (
    <LegalLayout
      eyebrow="House rules"
      title="Terms & Conditions"
      testId="terms-page"
    >
      <p>
        By making a reservation at Mrinmaya vacation home, you and every guest in
        your group agree to the following house rules. They exist to keep our
        space safe, peaceful, and enjoyable for everyone who stays here.
      </p>
      <ol className="mt-6 space-y-6 list-none counter-reset:mrn">
        {TERMS.map((t, idx) => (
          <li
            key={t.title}
            data-testid={`terms-item-${idx}`}
            className="border-l-2 border-mrn-terracotta pl-5"
          >
            <div className="text-xs uppercase tracking-[0.25em] text-mrn-terracotta font-medium">
              Rule {String(idx + 1).padStart(2, "0")}
            </div>
            <h3 className="mt-1 font-display text-2xl text-mrn-wood">
              {t.title}
            </h3>
            <p className="mt-2 text-mrn-wood-soft">{t.body}</p>
          </li>
        ))}
      </ol>
      <p className="mt-12 text-sm text-mrn-wood-soft">
        Repeated or serious violations may result in immediate termination of the
        stay without refund. If you have any questions about these rules ahead of
        your visit, please reach out — we’re happy to help.
      </p>
    </LegalLayout>
  );
}
